// productLang.ts — дверь словаря продукта (§15.2 спеки .claude/specs/2026-09-20-notifications.md):
// GET /api/i18n/products/{slug}?locale= отдаёт текстовый словарь продукта-источника, которым
// Оболочка подставляет видимый текст уведомления — текст остаётся собственностью продукта
// (CLAUDE.md п.5), дверь его только читает с диска и раздаёт. Права на продукт не требуются
// (§15.3) — человек мог получить уведомление от продукта, к которому у него нет доступа.
//
// Минуем apiFetch (client.ts): 404 здесь штатный ответ ("словаря нет"), а не общая ошибка с
// тостом. Дверь отдаёт ETag (условный GET), но фронт словарь продукта не переспрашивает повторно
// в рамках вкладки (ensureLoaded в productDict.ts запрашивает slug+locale один раз и держит в
// памяти) — If-None-Match кэшировать было бы нечем сверять, код снят как мёртвый.
// Зависший запрос не должен держать рельс: через 8 с словарь считается недоступным.
const PRODUCT_LANG_TIMEOUT_MS = 8000;
export async function fetchProductLang(slug, locale) {
    const ctrl = new AbortController();
    const timer = window.setTimeout(() => ctrl.abort(), PRODUCT_LANG_TIMEOUT_MS);
    try {
        const res = await fetch(`/api/i18n/products/${encodeURIComponent(slug)}?locale=${encodeURIComponent(locale)}`, {
            credentials: "same-origin",
            signal: ctrl.signal,
        });
        if (!res.ok)
            return { status: "not-found" };
        const data = (await res.json());
        return { status: "ok", data };
    }
    catch {
        // Таймаут и сеть — то же «словаря нет»: рельс ждёт словари и не должен виснуть на одном запросе.
        return { status: "not-found" };
    }
    finally {
        window.clearTimeout(timer);
    }
}
